export const BADGE_JOINED_SCRIPT_PATTERN = /[\u0590-\u08FF\u0900-\u109F\uFB1D-\uFDFF\uFE70-\uFEFF]/;
